// extracted by mini-css-extract-plugin
export default {"logoBanner":"Header_logoBanner__Xxmae","cancel":"Header_cancel__pk7a2"};